import styled from 'styled-components';

const Container = styled.div`
  display: inline-flex;
  margin-top: 2px;
  margin-left: 10px;
`;

export default Container;
